module.exports = __webpack_public_path__ + "static/media/Rectangle 85 (2).93022b41.jpg";